// A membership request is made on ASA's site, whose registration page asks what it needs and passes
// it on (the operator's choice, 2026-10-12: the panel's «درخواست عضویت» leads there).
export const ASA_REGISTRATION_URL = 'https://asatsp.ir/landings/registration'

// The online sign-up (2026-10-18) starts with the mobile code on this page; a new account without a
// business then lands on the online registration (ONLINE_REGISTRATION_PATH).
export const REGISTER_MOBILE_PATH = '/auth/registerMobile'
